import { Injectable } from '@angular/core';
import { testing } from './testing'

import 'firebase/functions';
import { getFunctions, connectFunctionsEmulator, httpsCallable } from 'firebase/functions';

@Injectable({
  providedIn: 'root'
})
export class CloudFunctionsService {

  functions = getFunctions()

  constructor() { 
    //enable for testing
    if(testing) connectFunctionsEmulator(this.functions,'localhost', 5001) 
  }

  callFirebaseFunction(name, payload?) {
    return httpsCallable(this.functions, name, {timeout: 540000})(payload)
  }

  async callHttpFunction(url: string, key: string) {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        "auth": key,
    }})

    if(response.status !== 200) {
      console.log("Something went wrong!")
      return
    }
  
    return await response.json()
  }

}
